import { render, staticRenderFns } from "./cjbcpmx.vue?vue&type=template&id=54991189&scoped=true&"
import script from "./cjbcpmx.vue?vue&type=script&lang=js&"
export * from "./cjbcpmx.vue?vue&type=script&lang=js&"
import style0 from "./cjbcpmx.vue?vue&type=style&index=0&id=54991189&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54991189",
  null
  
)

export default component.exports